import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { CallflowUpdatePartialDoc } from 'types/callflow';
import { Contact } from 'types/contact';
import { DeviceUpdatePartialDoc } from 'types/device';
import contactQueryKeys from 'app/hooks/queries/contact/contactQueryKeys';

export const useUpdateContactPartial = () => {
  const authState = useAuthSelector();
  const queryClient = useQueryClient();
  return useMutation<any, AxiosError, Contact, unknown>(
    (data: Contact) =>
      sdk.contact.mutate.updatePartial(
        {
          ...data,
          // other values such as "accept_charges" could go here
        },
        {
          authToken: authState?.auth_token,
        },
      ),
    {
      onSuccess: resp => {
        // this always runs, even if the caller provides an onSuccess
        queryClient.invalidateQueries(contactQueryKeys.all);
        // console.log('val:', val);
      },
    },
  );
};
